import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";

// eslint-disable-next-line
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ToastError } from "../../../Components/utils/ToastMessage";
import swal from "sweetalert";
import NotifyModal from "../notifications/modal";
function Warehouse() {
    const Navigate = useNavigate();
    const [forcePage, setForcePage] = useState(1);
    const [params, setparams] = useSearchParams();
    const [tableLoad, setTableLoad] = useState(false);
    const [pageCount, setpageCount] = useState(1);
    const [mobile, setMobile] = useState(null);
    const [categoryItems, setcategoryItems] = useState([]);
    const [showPaginate, setShowPagiate] = useState(true);
    const [showNotificationModal, setShowModal] = useState(false);
    const [NotificationID, setNotificationId] = useState("");
    let [loading, setLoading] = useState(true);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const onClose = () => {
        setShowModal("");
        setNotificationId("");
    };
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getcategories = (page) => {
        Services.Mobility_GetUsers("GET", null, token, page, mobile)
            .then((res) => {
                if (res.Status === 1) {
                    setcategoryItems(res.Users);
                    setTableLoad(false);
                    setLoading(false);
                    setpageCount(res?.Pagination?.totalPages);
                    if (res?.Pagination?.totalPages == 0) {
                        setShowPagiate(false);
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
                setTableLoad(false);
            });
    };
    useEffect(() => {
        const handler = setTimeout(() => {
            if (params.get("page")) {
                getcategories(params.get("page"));
                setForcePage(Number(params.get("page") - 1));
            }
        }, 1000);
        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line
    }, [mobile]);

    const emptyFormatter = (cell) => {
        if (cell) {
            return cell;
        } else {
            return "NA";
        }
    };
    const clcikHanlder = (row, type) => {
        swal(
            `Are You sure you want to ${type == 0 ? "unblock" : "block"} user?`,
            {
                icon: "warning",
                className: dashboardclasses["logout-popup"],
                dangerMode: true,
                buttons: {
                    cancel: "Cancel",
                    catch: {
                        text: type == 0 ? "unblock" : "block",
                        value: "Delete",
                        className: dashboardclasses[".cancel-delete"],
                    },
                    defeat: false,
                },
            }
        ).then((value) => {
            switch (value) {
                case "Delete":
                    setLoading(true);
                    Services.MobilityDriverUserUpdate(
                        "PATCH",
                        JSON.stringify({ blocked: type }),
                        token,
                        row.id
                    )
                        .then((res) => {
                            if (res.Status === 1) {
                                getcategories();
                                toast.success(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                            } else if (res.Status === 0) {
                                setLoading(false);
                                toast.error(`${res.Message}`, {
                                    position: "top-center",
                                    autoClose: 1000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                });
                                if (res.Message === "Token expired") {
                                    Navigate("/");
                                }
                            }
                        })
                        .catch((err) => {
                            // alert(err);
                            setLoading(false);
                            alert("something went wrong please try again");
                            console.log(err);
                        });
                    break;

                // default:
                //     swal("Got away safely!");
            }
        });
    };
    const ActionFormatter = (cell, row) => {
        return (
            <div className={dashboardclasses["Action_handler"]}>
                <button
                    onClick={() => clcikHanlder(row, row.blocked == 0 ? 1 : 0)}
                    className={
                        row.blocked == 0
                            ? dashboardclasses["red"]
                            : dashboardclasses["green"]
                    }>
                    {row.blocked == 0 ? "Block" : "Unblock"}{" "}
                </button>
                <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    onClick={(e) => {
                        {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowModal(true);
                            setNotificationId(row.id);
                        }
                    }}>
                    Notify
                </button>
            </div>
        );
    };
    const columns = [
        {
            dataField: "name",
            text: "NAME",
            sort: false,
            formatter: emptyFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "mobile",
            text: "MOBILE NUMBER",
            formatter: emptyFormatter,
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "gender",
            text: "GENDER",
            formatter: emptyFormatter,
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "city",
            text: "CITY",
            formatter: emptyFormatter,
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "dob",
            text: "DOB",
            sort: false,
            formatter: emptyFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
        {
            dataField: "createdAtFormatted",
            text: "REGISTERED",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "Actions",
            text: "Actions",
            sort: false,
            formatter: ActionFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles, width: "100px" };
            },
        },
    ];
    const handlePageChange = (selectedObject) => {
        console.log(selectedObject);
        setForcePage(selectedObject.selected);
        window.scrollTo({ top: 10, behavior: "instant" });
        // Navigate(`/purchaseorder?page=${selectedObject.selected + 1}`);
        setparams({ page: selectedObject.selected + 1 });
        getcategories(selectedObject.selected + 1);
        setTableLoad(true);
    };
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const searchHandler = (e) => {
        setTableLoad(true);
        setparams({ page: 1 });
        setForcePage(1);

        setMobile(e.target.value);
    };
    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            e.preventDefault();
            Navigate(`/mobility-services/user-details/${row.id}`);
        },
    };
    return (
        <>
            {/*   {category && (
                <AddCategory
                    setmodal={setCategory}
                    editable={editable}
                    setEditable={setEditable}
                    getCategories={getcategories}
                    setpageCount={setpageCount}
                    tableload={setTableLoad}
                />
            )} */}
            {showNotificationModal && NotificationID && (
                <NotifyModal
                    onClose={onClose}
                    open={showNotificationModal}
                    userId={NotificationID}
                />
            )}
            <Layout Active={"Users_mobility"}>
                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        <h3>Users</h3>

                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <div
                                    className={
                                        dashboardclasses["category-form-two"]
                                    }>
                                    <input
                                        type={"text"}
                                        placeholder="search by mobile"
                                        onChange={searchHandler}
                                    />
                                </div>
                                {tableLoad ? (
                                    <div className={dashboardclasses["loader"]}>
                                        <ScaleLoader
                                            color={"black"}
                                            loading={true}
                                            css={override}
                                            size={150}
                                        />
                                    </div>
                                ) : (
                                    <div className="category-table">
                                        <BootstrapTable
                                            bootstrap4
                                            keyField="mobile"
                                            data={categoryItems}
                                            columns={columns}
                                            defaultSorted={defaultSorted}
                                            rowEvents={tableRowEvents}
                                            wrapperClasses="table-responsive"
                                        />
                                        {showPaginate && (
                                            <div
                                                style={{
                                                    justifySelf: "right",
                                                }}>
                                                <ReactPaginate
                                                    pageCount={pageCount}
                                                    marginPagesDisplayed={2}
                                                    onPageChange={
                                                        handlePageChange
                                                    }
                                                    forcePage={forcePage}
                                                    breakClassName={"page-item"}
                                                    breakLinkClassName={
                                                        "page-link"
                                                    }
                                                    containerClassName={
                                                        "pagination"
                                                    }
                                                    pageClassName={"page-item"}
                                                    pageLinkClassName={
                                                        "page-link"
                                                    }
                                                    previousClassName={
                                                        "page-item"
                                                    }
                                                    previousLinkClassName={
                                                        "page-link"
                                                    }
                                                    nextClassName={"page-item"}
                                                    nextLinkClassName={
                                                        "page-link"
                                                    }
                                                    activeClassName={"active"}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Warehouse;
